export const environment = {
  production: false,
  environmentName: 'DEV',
  apiUrl: 'https://qa.appcore.jcb.com/api',
  hubWebUrl: 'https://hub.dev.appcore.jcb.com',
  enableLogging: true,
  enableDebugInfo: true,
  cacheTimeout: 300000, // 5 minutes
  googleAnalyticsId: 'G-E2ZXVS8GGT',
  jcbPortal: 'https://businesstest.jcb.com/',
};
